import React, { useState } from "react";
import { gql } from "apollo-boost";
import { useSubscription } from "@apollo/react-hooks";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Button,
} from "reactstrap";
import { Spinner } from "../../UI/spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { BlockRow } from "./BlockRow";
import { Stars } from "../../UI/Stars";

const LAST_TEN_TX_SUBSCRIPTION = gql`
  subscription lastTransactions($offset: Int!) {
    blocks_public(limit: 24, offset: $offset, order_by: { timestamp: desc }) {
      id
      height
      delegate {
        username
      }
      totalFee
    }
  }
`;

export const Blocks: React.FC = () => {
  const limit = 20;
  const [offset, setOffset] = useState(0);
  const { data, loading, error } = useSubscription(LAST_TEN_TX_SUBSCRIPTION, {
    variables: {
      offset,
    },
  });

  if (error) {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Blocks</CardTitle>
                </CardHeader>
                <CardBody>Error while fetching the blocks</CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
  if (loading) {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Blocks</CardTitle>
                  <CardBody>
                    <CardTitle tag="h4">
                      <Spinner /> Loading the last blocks
                    </CardTitle>
                  </CardBody>
                </CardHeader>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }

  return (
    <>
      <Stars />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 className="title">Blocks</h5>
              </CardHeader>
              <CardBody className="all-icons">
                <BlockRow blocks={data.blocks_public} />
                <Row>
                  <Col md="3">
                    {offset >= limit ? (
                      <Button
                        block
                        color="primary"
                        onClick={() => setOffset(offset - limit)}
                      >
                        Previous page
                      </Button>
                    ) : null}
                  </Col>
                  <Col md="6" />
                  <Col md="3">
                    <Button
                      block
                      color="primary"
                      onClick={() => setOffset(offset + limit)}
                    >
                      Next page
                    </Button>
                  </Col>
                </Row>
                <ReactTooltip />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
